import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { BiCalendar } from 'react-icons/bi';
import { FiFileText } from 'react-icons/fi';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import formatPrice from '../../services/utils/formatPrice';
import { navigationUrl } from '../../store/analytic/actions';
import { page } from '../../store/auth/actions';
import {
  setContractInformations,
  setSelectedInstallments,
  setSelectedPaymentMethod,
} from '../../store/contract/actions';
import { getUpdateDebts } from '../../store/contract/actions';
import getContractDescription from '../../utils/getContractDescription';
import { getContractsFromList } from '../../utils/getContractsToShow';
import getOriginalContract from '../../utils/getOriginalContract';
import {
  Content,
  Container,
  ContractDescription,
  DetailContent,
  DiscountContent,
  IconContent,
  IconTimer,
  Subtitle,
  Title,
  Wrapper,
} from './styles';
import { getDealState } from '../../store/negotiation/actions';
import { agreementStatusForDebts, CREDITOR_DEAL_STATUS, statusNameChange } from '../Agreement/constants';
import { CardContainer } from '../Agreement/styles';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { setAgreementStatus } from '../../store/agreement/actions';

const Contract: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { contractsLoading, list, listAgreements, AgreementsLoading } = useSelector((state: ApplicationState) => ({
    list: state.contract.list,
    contractsLoading: state.contract.contractsLoading,
    listAgreements: state.agreement.list,
    AgreementsLoading: state.agreement.agreementDebtLoading,
  }));

  const [agreementsFiltered, setAgreementsFiltered] = useState<GQL.IDeal[] | undefined>(undefined)

  const contractsToShow = useMemo(() => getContractsFromList(list), [list]);
  const contractsToShowAgreements = useMemo(() => getContractsFromList(agreementsFiltered ?? []), [agreementsFiltered]);

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/visualizouDivida',
      })
    );
    dispatch(getUpdateDebts.request());
    dispatch(page('contrato'));
  }, [dispatch]);

  useEffect(() => {
    setAgreementsFiltered(listAgreements.filter(agreement => agreementStatusForDebts.includes(agreement.status)));
  }, [listAgreements])

  useEffect(() => {
    dispatch(setContractInformations(null));
    dispatch(setSelectedInstallments([]));
    dispatch(setSelectedPaymentMethod(null));
    dispatch(getDealState.success([]))
  }, [dispatch]);

  const handleSelectProposal = async (contract: GQL.IDebt) => {
    dispatch(
      setContractInformations({
        databaseId: contract.databaseId,
        creditorId: contract.creditorId,
      })
    );

    history.push({ pathname: '/faturas', state: { contract } });
  };

  const handlerDeal = (agreement: GQL.IDeal) => {
    dispatch(
      setContractInformations({
        databaseId: agreement.databaseId,
        creditorId: agreement.creditorId,
      })
    );
  
    dispatch(setAgreementStatus(agreement.status));
    history.push({ pathname: '/parcela-acordo', state: { agreement } });
  };

  return (
    <>
      {contractsLoading || AgreementsLoading ? (
        <>
          <Wrapper>
            <Skeleton className='title' />
            <Skeleton className='subtitle' />
            <Skeleton className='contract' />
            <Skeleton className='contract' />
          </Wrapper>
        </>
      ) : (
        <>
          {list.length > 0 || (agreementsFiltered && agreementsFiltered.length > 0) ? (
            <Wrapper>
              <Container>
                <Title>Meus Débitos</Title>
                <Subtitle>
                  Selecione um contrato abaixo para ver mais detalhes
                </Subtitle>
                {list.length > 0 && list.map((contract, index) => (
                  <Content
                    key={index}
                    onClick={() => handleSelectProposal(contract)}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <DetailContent>
                        <div className='number'>
                          R$ {formatPrice(contract.updatedValue)}
                        </div>
                        <p className='debt-description'>O valor contém juros e encargos sob o original</p>
                        <div className='bank-name'>{contract.creditorName}</div>
                        <div className='default'>
                          <FiFileText className='space-right' />
                          {contract.contracts.length > 1 ? (
                            'Múltiplos contratos'
                          ) : (
                            <span>
                              Contrato:
                              <span className='bold'>
                                {contractsToShow &&
                                  getOriginalContract(
                                    contractsToShow[index][0]
                                  )}
                              </span>
                            </span>
                          )}
                        </div>
                        {contract.proposalDueDate && (
                          <div className='default2'>
                            <BiCalendar className='space-right' />
                            Proposta válida até{' '}
                            <span className='bold'>
                              {moment(contract.proposalDueDate).format(
                                'DD/MM/YYYY'
                              )}
                            </span>
                          </div>
                        )}
                      </DetailContent>
                      {contract.discountPercentage && (
                        <DiscountContent>
                          <div>
                            desconto até{' '}
                            <span>{contract.discountPercentage}%</span>
                          </div>
                        </DiscountContent>
                      )}
                      <IconContent>
                        <IconTimer />
                        <div>{contract.longerDelay} dias de atraso</div>
                      </IconContent>
                    </div>
                    {contractsToShow?.length === 1 ? (
                      <ContractDescription>
                        {getContractDescription(contractsToShow[index][0])}
                      </ContractDescription>
                    ) : (
                      <></>
                    )}
                  </Content>
                ))}

                {agreementsFiltered && agreementsFiltered.length > 0 &&
                  agreementsFiltered.map((agreement, index) => {
                    return (
                      <CardContainer
                        key={agreement.dealId}
                        onClick={() => handlerDeal(agreement)}
                      >
                        <div className='row'>
                          <div className='left'>
                            <p className='portion'>
                              <FaFileInvoiceDollar
                                id='icon'
                                style={{ height: 14 }}
                              />{' '}
                              Parcela atual{' '}
                              {`(${agreement.portion}/${agreement.plan})`}: R$
                              {formatPrice(agreement.portionValue ?? 0)}
                            </p>
                            <p className='default'>
                              <BiCalendar style={{ height: 14 }} /> Vencimento
                              parcela atual{' '}
                              <strong style={{ fontSize: 14 }}>
                                {moment(agreement.portionDueDate).format(
                                  'DD/MM/YYYY'
                                )}
                              </strong>
                            </p>
                            <p className='default'>
                              <FiFileText style={{ height: 14, marginRight: 4 }} />
                              {agreement.contracts?.length > 1
                                ? `Múltiplos contratos`
                                : `Contrato: `}
                              {agreement.contracts?.length === 1 && (
                                <strong>
                                  {contractsToShowAgreements &&
                                    getOriginalContract(contractsToShowAgreements[index][0])}
                                </strong>
                              )}
                            </p>

                            <p className='default'>
                              <FiFileText style={{ height: 14, marginRight: 4 }} />
                              Status:
                              <strong>
                                {' '}
                                {statusNameChange[agreement.status] ??
                                  agreement.status}
                              </strong>
                            </p>
                          </div>
                          <div className='right'>
                            <p className='text'>Valor total:</p>
                            <p className='price'>
                              <span>Valor total: </span>R${' '}
                              {formatPrice(agreement.totalPlanValue ?? 0)}
                            </p>
                            <p className='bank'>{agreement.creditorName}</p>
                          </div>
                        </div>

                        {contractsToShowAgreements.length === 1 ? (
                          <ContractDescription>
                            {getContractDescription(contractsToShowAgreements[index][0])}
                          </ContractDescription>
                        ) : (
                          <></>
                        )}
                      </CardContainer>
                    )
                  })
                }
              </Container>
            </Wrapper>
          ) : (
            <Wrapper>
              <Container>
                <Title>Meus Débitos</Title>
                <Subtitle>Não há débitos disponíveis</Subtitle>
              </Container>
            </Wrapper>
          )}
        </>
      )}
    </>
  );
};

export default Contract;
